import React from 'react';
import {GuideAppContainer, RenderOnlyFor, useGuideConfig, useNeuroMessages} from '@ignitesales/neuro-application';
import CustomSocialActionBar from './CustomSocialActionBar';
import ThemeRunnerTool from "./ThemeRunnerTool";

const DialogueThemeContainer = ({ children }) => {
    const { getMessage } = useNeuroMessages();
    const { isDemoMode } = useGuideConfig();
    //Update DOM title (can be better done via publishing with 'title.default')
    document.title = getMessage('guide.name');

    return <GuideAppContainer className="dialogue-theme" useDevelopmentTool={!isDemoMode}>
        { children }
        <RenderOnlyFor forSummaryPage={true} forDetailsPage={true}>
            <CustomSocialActionBar useStackedLayout={true}  />
        </RenderOnlyFor>
        { !isDemoMode && <ThemeRunnerTool /> }
    </GuideAppContainer>;
};

export default DialogueThemeContainer;
